module.exports = __webpack_public_path__ + "fonts/KFOkCnqEu92Fr1MmgVxGIzIFKw.7fa60a10.woff2";